import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import MapToolInfoComponent from './widgets/info/MapToolInfoComponent';
import Point from "@arcgis/core/geometry/Point";

const MapToolComponent = forwardRef(({mapDiv, mapView, table,
    mapConfig, selectedTool}, ref) => {

    const [mapClickHandler, setMapClickHandler] = useState();
    const [event, setEvent] = useState();

    const componentMapClick = (e) => {
        if (selectedTool != null) {
            setEvent(e);
            console.log('event',e.mapPoint)
        }
    };

    useEffect(() => {
        if (mapClickHandler) mapClickHandler.remove();
        let handler = mapView.on("click", componentMapClick);
        setMapClickHandler(handler);
        setEvent(null);
    }, [selectedTool])

    useImperativeHandle(ref, () => ({}));

    return (
        <>
            {selectedTool == "info" && event != null &&
            <MapToolInfoComponent mapDiv={mapDiv} mapView={mapView} table={table}
                mapConfig={mapConfig}
                event={event} setEvent={setEvent}/>}
        </>
    )
});
export default MapToolComponent;



